import { Flex, type GridColDef, Text } from '@shared/components';

export interface AdminExamLocationManagementGrantAccessRoomListItem {
  id: string;
  province: string;
  location: {
    locationName: string;
    buildingName: string;
    floorName: string;
  };
  room: {
    roomName?: string;
    roomNumber?: string;
  };
  lastUpdatedAt: string;
}

export const columns: GridColDef<AdminExamLocationManagementGrantAccessRoomListItem>[] = [
  {
    field: 'province',
    headerName: 'จังหวัด',
    sortable: false,
    width: 144,
    renderCell: ({ row }) => {
      const { province } = row;
      return <Text>{province}</Text>;
    },
  },
  {
    field: 'location',
    headerName: 'สถานที่สอบ / อาคาร / ชั้น',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => {
      const { location } = row;
      return (
        <Flex sx={{ flexDirection: 'column' }}>
          <Text variant='body1Semibold'>{location.locationName}</Text>
          <Text sx={(theme) => ({ color: theme.palette.text.secondary })}>
            อาคาร: {location.buildingName} ชั้น: {location.floorName}
          </Text>
        </Flex>
      );
    },
  },
  {
    field: 'room',
    headerName: 'ห้องสอบ',
    sortable: false,
    width: 300,
    renderCell: ({ row }) => {
      const { room } = row;
      return (
        <Flex sx={{ flexDirection: 'column' }}>
          <Text>ห้อง: {room.roomName ?? '-'}</Text>
          <Text>เลขที่: {room.roomNumber ?? '-'}</Text>
        </Flex>
      );
    },
  },
  {
    field: 'lastUpdatedAt',
    headerName: 'แก้ไขข้อมูลล่าสุด',
    sortable: false,
    width: 184,
    renderCell: ({ row }) => {
      const { lastUpdatedAt } = row;
      return <Text>{lastUpdatedAt}</Text>;
    },
  },
];
